import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  GrooveActionDirective,
  GrooveHeroComponent,
  GrooveStatStripDirective,
} from '@groove/angular';
import { ContactDetailsComponent } from '../../../content/contact-details/contact-details.component';
import { PageCtaComponent } from '../../../content/page-cta/page-cta.component';
import { PageExploreComponent } from '../../../content/page-explore/page-explore.component';
import { YoutubeSectionComponent } from '../../../content/youtube-section/youtube-section.component';
import { DATA_CONFIG } from '../../../injection-tokens';
import { SEOService } from '../../../seo.service';
import { buildXPlorationJazzPageSchemas } from './x-ploration-jazz-jsonld';

@Component({
  selector: 'app-x-ploration-jazz-content',
  imports: [
    RouterLink,
    ContactDetailsComponent,
    GrooveActionDirective,
    GrooveHeroComponent,
    GrooveStatStripDirective,
    PageCtaComponent,
    PageExploreComponent,
    YoutubeSectionComponent,
  ],
  templateUrl: './x-ploration-jazz-content.component.html',
  styleUrl: './x-ploration-jazz-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XPlorationJazzContentComponent implements OnDestroy {
  // Hero actions read the shared tel:/mailto: targets. <app-contact-details>
  // and the bottom reprise resolve them from DATA_CONFIG themselves.
  private readonly dataConfig = inject(DATA_CONFIG);
  private seo = inject(SEOService);
  protected readonly phoneHref = this.dataConfig.phoneHref;
  protected readonly emailHref = this.dataConfig.emailHref;

  constructor() {
    // No route param to react to, so a plain constructor call is enough —
    // this page's JSON-LD never changes after mount. Sets the MusicGroup +
    // VideoObject schemas that used to live in app.routes.ts's static
    // data.seo.jsonLd; see x-ploration-jazz-jsonld.ts for why this moved.
    this.seo.setRouteSchemas(buildXPlorationJazzPageSchemas());
  }

  ngOnDestroy(): void {
    this.seo.clearRouteSchemas();
  }
}
